import React from 'react';
// import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

// from {Redirect} import 'react-router-dom'

import { userActions } from '../_actions';
// import FacebookLogin from 'react-facebook-login'
import {GoogleLogin} from 'react-google-login'
// import { RegisterPage } from '../RegisterPage';
// import { history } from '../_helpers';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

import './LoginPage.scss'

import UserConsumer from '../context/context'

// import {isSafari} from 'react-device-detect';


// import logo from '../f_logo_RGB-White_58.png'

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        // this.props.logout();

        this.state = {
            username: '',
            email: '',
            password: '',
            fbtoken: '',
            googletoken: '',
            submitted: false,
            valid: false,
            open: true,
            reload: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    
    componentDidMount(){
        console.log("DID MOUNT")
        

    }
    handleChange(e) {
        const { name, value} = e.target;
        let {valid, email, password} = this.state


        if (name==='email') email = value
        else if (name==='password') password = value


        valid = true
        
        // console.log(email.split('@')[1], password)

        // console.log(valid)

        this.setState({ [name]: value, valid, });

        
        
    }

    handleSubmit(e) {
        console.log(e)
        // console.log(this.state.username)
        // console.log(this.state.password)
        // debugger
        e.preventDefault();
        // const letters = /[a-z]/g;
        // const numbers = /[0-9]/g;
        

        this.setState({ submitted: true });
        let { email, password, valid } = this.state;
        if (valid) {
            // let url_test = 'http://localhost:8000/user/confirm/' + '?email=' + email
            let url = 'https://qurator.co.kr/user/confirm/' + '?email=' + email
            fetch(url, {
                method:'GET',
                })
                .then(response => {
                    console.log(response)
                    if(response.status===200){
                        this.props.login(email, password, window.location)
                    }
                    else{
                        this.props.register({
                            "email": email,
                            "password": password
                        })
                    }
                }
                )
            
            
        }
        else{
            alert("Invalid Email/Password")
            this.setState({
                username: '',
                password: '',
                email: '',
                valid: false
            })
        }

        
        // console.log(email)
        // console.log(password)
    }

    facebookResponse = (e) => {
        localStorage.clear()
        // console.log(e)
        // this.setState({
        //     submitted: true,
        //     fbtoken: e.accessToken,
        // })

        if (e.accessToken){
            this.props.tokenLogin(e, e.accessToken, 'facebook');
        }

        // console.log(localStorage)
    };

    googleResponse = (e) => {
        localStorage.clear()
        
        console.log(e.accessToken)

        if(e.accessToken){
            this.props.tokenLogin(e, e.accessToken, 'google', window.location);
        }

        
        // }

    };
    getRndInteger=(min, max)=> {
        return Math.floor(Math.random() * (max - min + 1) ) + min;
      }

    _randomColor=()=>{
        // let randomNumber = 'rgba(' + 
        // this.getRndInteger(100, 255) + ',' + 
        // this.getRndInteger(100, 255) + ',' + 
        // this.getRndInteger(100, 255) + ',' + 
        // '0.8)'

        let randomNumber = 'rgba(155, 155, 155, 0.8)'

        return(randomNumber)
        
    }

    render() {
        // const { loggingIn } = this.props;
        const {email, password} = this.state;

        // const letters = /[a-z]/g;
        // const numbers = /[0-9]/g;

        // console.log(this.state.valid)

        // history.replaceState(null, null, '/login')
        return (
            // <div className="LoginPage">
                <div className="LoginPage-main">
                    
                        
                    <h2>QURATOR</h2>

                    
                    <GoogleLogin
                        className="LoginPage-googleBtn"

                        clientId="770117156200-0movqloq3jb2k9jtic70p826h2runf8n.apps.googleusercontent.com"
                        // clientId="689657594888-k0cnuthgja9vm0ke8hoc2ql2s0p2r9ha.apps.googleusercontent.com"
                        buttonText="LOGIN WITH GOOGLE"
                        onSuccess={this.googleResponse}
                        onFailure={result => {console.log(result); this.setState({reload:!this.state.reload})}}
                        // prompt="consent"
                        // accessType="code"
                        cookiePolicy={'single_host_origin'}
                    />
                    
                    
                    <div className={this.state.open ? "LoginPage-folder" : "LoginPage-folder-sub"} onClick={()=>this.setState({open: !this.state.open})}>▲ </div>

                    
                    <form className={this.state.open?"LoginPage-form-sub":"LoginPage-form"} name="form" onSubmit={this.handleSubmit}>
                        
                        <div className="LoginPage-formGroup">
                            <label htmlFor="email">Email</label>
                            <input type="text" name="email" value={email} onChange={this.handleChange} />
                            {!email ?
                                <div className="help-block">email is required</div>
                                : email.split('@')[1] !== 'obelab.com' &&
                                <div className="help-block">only @obelab.com is available</div>
                            }
                        </div>
                        <div className="LoginPage-formGroup">
                            <label htmlFor="password">Password</label>
                            <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                            {!password ?
                                <div className="help-block">Password is required</div>
                                :  (password.length <8) && 
                                <div className="help-block">More than 8 letters + numbers</div>
                            }
                        </div>
                        <div className="LoginPage-formGroup" id="LoginPage-BtnGroup">
                            <button className="LoginPage-loginbtn">Login</button>
                            
                            
                            {/* <Link to="/register" className="LoginPage-a">
                                <button href={'/register'} className="LoginPage-regibtn">Register
                                </button>
                            </Link> */}
                            
                        </div>
                    </form>
                        
                    
                    
                    
                    {/* <div><svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fill-rule="evenodd"><path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z" fill="#EA4335"></path><path d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"></path><path d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z" fill="#FBBC05"></path><path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z" fill="#34A853"></path><path fill="none" d="M0 0h18v18H0z"></path></g></svg></div> */}

                    {/* <FacebookLogin
                        appId="481836502653209"
                        autoLoad={false}
                        fields="name,email,picture"
                        callback={this.facebookResponse} 
                        render={renderProps => (
                            <button className="LoginPage-fbbtn" onClick={renderProps.onClick}>FACEBOOK</button>
                                // <img className="LoginPage-fbbtn" onClick={renderProps.onClick} src={logo}></img>
                          )}
                        /> */}
                </div>

        );
    }
}

function mapState(state) {
    const { loggingIn } = state.authentication;
    return { loggingIn };
}

const actionCreators = {
    login: userActions.login,
    register: userActions.register,
    logout: userActions.logout,
    tokenLogin: userActions.tokenLogin
};

const connectedLoginPage = connect(mapState, actionCreators)(LoginPage);
export { connectedLoginPage as LoginPage };